// Same as front-end/src/components/logo/LogoMain.tsx, minus the per-company logo (a partner
// has none). Dark mode uses the warm-white version of the mark.
import { nuwaySymbol } from "./brand";
import useConfig from "hooks/useConfig";
import { ThemeMode } from "types/config";

// ==============================|| LOGO SVG ||============================== //

const LogoMain = ({ reverse }: { reverse?: boolean }) => {
  const { mode } = useConfig();

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        width: "100%",
      }}
    >
      <img
        src={nuwaySymbol(mode === ThemeMode.DARK || reverse)}
        alt="Nuway"
        width="36"
        height="36"
      />
    </div>
  );
};

export default LogoMain;
